import { useState } from "react";
import { useData } from "../../context/DataContext";
import { Card, CardHead, TableWrap, Th, Td, Pill, EmptyState, IconBtn } from "../kit";
import { fmtINR, uid, todayStr } from "../../lib/finance";
import { toast } from "sonner";
import { CheckCircle2, Trash2 } from "lucide-react";

export default function Pipeline() {
  const { pipeline, savePipeline, entries, saveEntries } = useData();
  const rows = pipeline.slice().sort((a, b) => (a.expectedDate || "").localeCompare(b.expectedDate || ""));
  const [editId, setEditId] = useState(null);
  const [ev, setEv] = useState({});

  const startEdit = (p) => { setEditId(p.id); setEv({ ...p }); };
  const saveEdit = async () => {
    await savePipeline(pipeline.map((p) => (p.id === editId ? { ...p, brand: ev.brand, expectedAmount: parseFloat(ev.expectedAmount) || 0, expectedDate: ev.expectedDate, status: ev.status, notes: ev.notes } : p)));
    setEditId(null); toast.success("Pipeline entry updated");
  };
  const del = async (id) => { if (!window.confirm("Remove this from the pipeline?")) return; await savePipeline(pipeline.filter((p) => p.id !== id)); toast.success("Removed from pipeline"); };
  const finalize = async (p) => {
    const amountStr = window.prompt(`Confirmed amount for ${p.brand}?`, p.expectedAmount || 0);
    if (amountStr === null) return;
    const amount = parseFloat(amountStr);
    if (!amount || amount <= 0) return toast.error("Enter a valid amount");
    const dateStr = window.prompt("Date received?", p.expectedDate || todayStr());
    if (dateStr === null) return;
    await saveEntries([...entries, { id: uid(), type: "income", category: "Brand Collabs", amount, description: `${p.brand} (from pipeline)`, date: dateStr }]);
    await savePipeline(pipeline.filter((x) => x.id !== p.id));
    toast.success(`${p.brand} confirmed and added to income`);
  };

  return (
    <Card>
      <CardHead title="Brand Collab Pipeline" subtitle="Upcoming / unconfirmed collabs — not counted as income until confirmed" />
      <div className="mt-4">
        {rows.length === 0 ? <EmptyState>Nothing in the pipeline yet. Add one from "Add Entry" → Brand Collab → Upcoming.</EmptyState> : (
          <TableWrap>
            <thead><tr><Th>Brand</Th><Th className="text-right">Expected ₹</Th><Th>Date</Th><Th>Stage</Th><Th>Notes</Th><Th></Th></tr></thead>
            <tbody>
              {rows.map((p) => editId === p.id ? (
                <tr key={p.id} className="bg-slate-50">
                  <Td><input className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm" value={ev.brand || ""} onChange={(e) => setEv({ ...ev, brand: e.target.value })} /></Td>
                  <Td><input type="number" className="w-24 rounded-lg border border-slate-200 px-2 py-1 text-sm text-right" value={ev.expectedAmount || 0} onChange={(e) => setEv({ ...ev, expectedAmount: e.target.value })} /></Td>
                  <Td><input type="date" className="rounded-lg border border-slate-200 px-2 py-1 text-sm" value={ev.expectedDate || ""} onChange={(e) => setEv({ ...ev, expectedDate: e.target.value })} /></Td>
                  <Td>
                    <select className="rounded-lg border border-slate-200 px-2 py-1 text-sm" value={ev.status} onChange={(e) => setEv({ ...ev, status: e.target.value })}>
                      <option>Pipeline</option><option>In Talks</option><option>Verbally Confirmed</option>
                    </select>
                  </Td>
                  <Td><input className="w-full rounded-lg border border-slate-200 px-2 py-1 text-sm" value={ev.notes || ""} onChange={(e) => setEv({ ...ev, notes: e.target.value })} /></Td>
                  <Td><div className="flex gap-1"><IconBtn onClick={saveEdit} className="text-emerald-600">✓</IconBtn><IconBtn onClick={() => setEditId(null)}>✕</IconBtn></div></Td>
                </tr>
              ) : (
                <tr key={p.id} className="hover:bg-slate-50">
                  <Td className="font-medium text-slate-900">{p.brand}</Td>
                  <Td className="text-right tnum text-emerald-600 font-semibold">{fmtINR(p.expectedAmount || 0)}</Td>
                  <Td className="text-slate-500">{p.expectedDate || "—"}</Td>
                  <Td><Pill tone="brand">{p.status}</Pill></Td>
                  <Td className="text-slate-500">{p.notes}</Td>
                  <Td>
                    <div className="flex gap-1">
                      <IconBtn title="Mark confirmed" onClick={() => finalize(p)} className="text-emerald-600" data-testid={`finalize-${p.id}`}><CheckCircle2 className="h-4 w-4" /></IconBtn>
                      <IconBtn title="Edit" onClick={() => startEdit(p)}>✎</IconBtn>
                      <IconBtn title="Delete" onClick={() => del(p.id)} className="hover:text-rose-600"><Trash2 className="h-4 w-4" /></IconBtn>
                    </div>
                  </Td>
                </tr>
              ))}
            </tbody>
          </TableWrap>
        )}
      </div>
      <div className="h-4" />
    </Card>
  );
}
